import React, { useState, useRef, useEffect } from 'react';
import classes from './VideoPlayer.module.css';
import PrimaryButton from '../Buttons/PrimaryButton/PrimaryButton';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { urls } from '../../Routes/Urls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpand } from '@fortawesome/free-solid-svg-icons';

const VideoPlayer = ({ videoSrc, videoId, button = false }) => {
  const history = useHistory();
  const [isPlaying, setIsPlaying] = useState(true);
  const [showPlayButton, setShowPlayButton] = useState(true);

  const videoRef = useRef(null);

  const handlePlayPause = () => {
    const video = videoRef.current;
    if (isPlaying) {
      video.pause();
      setIsPlaying(false);
      setShowPlayButton(true);
    } else {
      video.play();
      setIsPlaying(true);
      setShowPlayButton(false);
    }
  };

  const handleFullScreen = () => {
    const video = videoRef.current;
    if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen();
    }  else if (video.webkitRequestFullScreen) {
      video.webkitRequestFullscreen();
    } else if (video.mozRequestFullScreen) {
      video.mozRequestFullScreen();
    } else if (video.msRequestFullscreen) {
      video.msRequestFullscreen();
    }
  };

  useEffect(() => {
    const video = videoRef.current;

    const handlePlay = () => {
      setIsPlaying(true);
      setShowPlayButton(false);
    };

    const handlePause = () => {
      setIsPlaying(false);
      setShowPlayButton(true);
    };

    video?.addEventListener('play', handlePlay);
    video?.addEventListener('pause', handlePause);

    return () => {
      video?.removeEventListener('play', handlePlay);
      video?.removeEventListener('pause', handlePause);
    };
  }, []);

  return (
    <div className={classes.mainContainer}>
      <div className={classes.videoFrame}>
        <video
          ref={videoRef}
          id="video"
          src={videoSrc}
          onClick={handlePlayPause}
          autoPlay
          muted
          loop
          playsInline
        />
        {showPlayButton && (
          <div className={classes.controlsContainer}>
            <div className={classes.playButton} onClick={handlePlayPause}>
              <div className={classes.playIcon} />
            </div>
            <FontAwesomeIcon
              icon={faExpand}
              className={classes.fullscreenIcon}
              onClick={handleFullScreen}
            />
          </div>
        )}
      </div>
      {button && (
        <PrimaryButton
          className={classes.btn}
          onClick={() => history.push(urls.LISTING)}
        >
          Explore Our Collection
        </PrimaryButton>
      )}
    </div>
  );
};

export default VideoPlayer;
